// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"9c0653f5","488":"7a876c9d","977":"4db89900"}[chunkId] + ".chunk.js";
};